import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon } from 'omni-common-ui';
import BadgeType from './type';

class AcademicOverviewBadge extends PureComponent {

  _getClassName(className) {
    switch (this.props.type) {
      case BadgeType.WARNING:
        return classnames(className, styles.__warning);
      case BadgeType.INFO:
        return classnames(className, styles.__info);
      default:
        return className;
    }
  }

  render() {
    return <div className={this._getClassName(styles.AcademicOverviewBadge)}>
      <div className={this._getClassName(styles.AcademicOverviewBadge_info)}>
        <span>{this.props.text}</span>
        <Icon id="arrow-down" className={styles.AcademicOverviewBadge_icon} />
      </div>
      <div className={styles.AcademicOverviewBadge_profile}>
        <span>{this.props.number}</span>
        <Icon id="toggle-session" className={styles.AcademicOverviewBadge_icon} />
      </div>
    </div>;
  }
}

AcademicOverviewBadge.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(Object.values(BadgeType)),
  number: PropTypes.number,
  text: PropTypes.string,
};

export default AcademicOverviewBadge;



// WEBPACK FOOTER //
// ./components/AcademicOverviewBadge/index.jsx